import { useEffect, useState } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

/**
 * Shows a toast when a new SW version is ready. User taps "reload" to swap
 * in the new build; dismissing keeps the old version alive for this session.
 */
export function UpdatePrompt() {
  const { t } = useTranslation();
  const [shown, setShown] = useState(false);

  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError(err) {
      console.warn('[sw] register error', err);
    },
  });

  useEffect(() => {
    if (needRefresh && !shown) {
      setShown(true);
      toast(t('common.update_available'), {
        duration: Infinity,
        action: {
          label: t('common.update_reload'),
          onClick: () => void updateServiceWorker(true),
        },
        onDismiss: () => setNeedRefresh(false),
      });
    }
  }, [needRefresh, shown, setNeedRefresh, t, updateServiceWorker]);

  return null;
}
